// extracted by mini-css-extract-plugin
export default {"root":"List_root__iCbpf","item":"List_item__fjywk","customEmpty":"List_customEmpty__6uoHR"};